import classnames from 'classnames';
import React, { forwardRef, Ref, useId } from 'react';

import '@eika/radio-button-style/src/RadioButton.scss';

import { RadioButtonProps } from './Types';

const RadioButton = forwardRef(
    (
        {
            value,
            name,
            selectedOption,
            onChange,
            id,
            inputRef,
            label,
            required,
            error,
            describedBy,
            className,
            dataTrackId,
            dataTrackLinkname,
            externalLabel = false,
            ...rest
        }: RadioButtonProps,
        ref: Ref<HTMLInputElement>,
    ): JSX.Element => {
        const generatedId = useId();
        const inputId = id ?? generatedId;

        return (
            <div
                className={classnames('sgw-radio-option', className, {
                    'sgw-radio-option__error': error,
                    disabled: rest.disabled,
                })}
            >
                {/* eslint-disable-next-line jsx-a11y/role-supports-aria-props */}
                <input
                    {...rest}
                    className="sgw-radio-option__input"
                    type="radio"
                    value={value}
                    name={name}
                    checked={value === selectedOption}
                    onChange={(event) => {
                        onChange(event.target.value);
                    }}
                    id={inputId}
                    ref={ref ?? inputRef}
                    aria-describedby={describedBy ?? rest['aria-describedby']}
                    required={required}
                    aria-invalid={error}
                    data-track-id={dataTrackId}
                    data-track-linkname={dataTrackLinkname}
                />

                {externalLabel ? (
                    <span className="sgw-radio-option__label">{label || value}</span>
                ) : (
                    <label className="sgw-radio-option__label" htmlFor={inputId}>
                        {label || value}
                    </label>
                )}
            </div>
        );
    },
);

export default RadioButton;
